import React, { Component } from 'react'
import anime from 'animejs'
import Helmet from 'react-helmet'
import SVG from '../components/SVG'
import Menu from '../components/Menu'
import Flower from '../components/Flower'
import {
  scaleUp,
  fadeIn,
  fadeInFromLeftAndRight,
  fadeInFromRight,
  fadeOutList,
  fadeOut,
  typing,
  translateY,
} from '../utils/animations'
import { Redirect } from 'react-router-dom'
import HeadingLR from '../components/Text/HeadingLR'
import TextList from '../components/Text/TextList'
import TypingText from '../components/Text/TypingText'
import Header from '../components/Header'
import Logo from '../components/Logo'
import AnimationControls from '../components/AnimationControls'

export default class Paid extends Component {
  constructor() {
    super()
    this._isMounted = false // Not an optimal solution.
    this.handleMenuClick = this.handleMenuClick.bind(this)
    this.state = {
      redirect: false,
    }
  }

  componentDidMount() {
    this._isMounted = true

    var controlsProgressEl = document.querySelector('#TLcontrols .progress')

    // Flower main screen animations.
    document.querySelector('#real-flower').style.display = 'none'
    anime(scaleUp('#petal-paid-dupli', [1, 10], 1000))
    anime(translateY('header', [0, -100]))
    anime(fadeIn('#TLcontrols', 1000))

    // Text animations.
    const controlledTimeline = anime
      .timeline({
        easing: 'linear',
        update: anim => (controlsProgressEl.value = anim.progress),
      })
      .add(fadeInFromLeftAndRight('.heading-left', 200, 800))
      .add(fadeInFromRight('.heading-right'))
      .add(fadeInFromLeftAndRight('.list-item', 0, 1500))
      .add(fadeOut(['.heading-left', '.heading-right'], 1500))
      .add(fadeOutList('.list-item', 0, 200))
      .add(typing('#typing-text-path-1', ['m0,180 h0', 'm0,180 h700'], 5000))
      .add(typing('#typing-text-path-2', ['m150,230 h0', 'm150,230 h350'], 2000))
      .add(fadeInFromRight('#animated-logo'))

    document.querySelector('#TLcontrols .play').onclick =
      controlledTimeline.play
    document.querySelector('#TLcontrols .pause').onclick =
      controlledTimeline.pause
    document.querySelector('#TLcontrols .restart').onclick =
      controlledTimeline.restart

    controlsProgressEl
      .addEventListener('input', () =>
        controlledTimeline
          .seek(controlledTimeline.duration * (controlsProgressEl.value / 100))
      );
    ['input', 'change'].forEach(evt =>
      controlsProgressEl.addEventListener(evt, () =>
        controlledTimeline
          .seek(controlledTimeline.duration * (controlsProgressEl.value / 100))
      )
    )
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  handleMenuClick() {
    if (this._isMounted)
      this.setState({ redirect: true })
  }

  render() {
    if (this.state.redirect)
      return <Redirect to={{ pathname: '/', state: { referrer: '/Paid', elementId: '#petal-paid-dupli' } }} />
    return (
      <div>
        <Helmet
          title={'Όνειρο - Παιδικός Σταθμός'}
          meta={[
            {
              name: 'description',
              content:
                "Όνειρο - σελίδα Παιδικού Σταθμού. Ο Παιδικός είναι αγάπη, εμπιστοσύνη, ασφάλεια, χαρά. Ο Παιδικός είναι 'Όνειρο'. ",
            },
          ]}
        />
        <Header>
          <SVG
            id={'header-logo'}
            height={'48px'}
            width={'350px'}
            viewBox={'20 0 220 150'}
          >
            <Logo />
          </SVG>
        </Header>
        <Menu handleMenuClick={this.handleMenuClick} color={'#1c2833'} />
        <main>
          <SVG id={'flower'} viewBox={`50 -40 680 700`} fitToScreen={true}>
            <Flower page={'Paid'} />
            <HeadingLR
              left={'Ο Παιδικός είναι '}
              right={'παιχνίδι '}
              color={'#1c2833'}
            />
            <TextList
              color={'#1c2833'}
              fontSize={'25px'}
              list={[
                'Παιχνίδι γνωριμίας',
                'Παιχνίδι επικοινωνίας',
                'Παιχνίδι συγκρότησης',
                'Παιχνίδι κοινωνικοποίησης',
                'Παιχνίδι συναισθηματικής εξέλιξης',
                'Παιχνίδι κινητικής εξέλιξης',
                'Παιχνίδι γλωσσικής καλλιέργειας',
                'Παιχνίδι προσωπικής και κοινωνικής ανάπτυξης',
              ]}
            />
            <TypingText
              number={1}
              fontSize={'25px'}
              content={'Ο Παιδικός είναι αγάπη, εμπιστοσύνη, ασφάλεια, χαρά.'}
              color={'#1c2833'}
            />
            <TypingText
              number={2}
              fontSize={'40px'}
              content={'Ο Παιδικός είναι'}
              color={'#1c2833'}
            />
            <g transform="scale(.8) translate(270, 310)">
              <Logo id={'animated-logo'} />
            </g>
          </SVG>
          <AnimationControls color={'deepgreen'} />
        </main>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/paidikos.js